import(/* webpackMode: "eager" */ "/vercel/path0/src/app/terms/privacy-policy/page.tsx");
